var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-table',{attrs:{"url":"/api/v1/supportTicket","row-classes":{
    'table-danger': model => {
      return (
        model.customer_profile && Boolean(model.customer_profile.deleted_at)
      );
    }
  },"filter":[
    {
      name: 'multiSort',
      mode: ['ASC', 'DESC'],
      attribute: ['read', 'created_at']
    }
  ],"attributes":[
    {
      name: 'ID',
      attribute: 'id'
    },
    {
      name: 'Name',
      attribute: 'customer_profile',
      type: 'LinkProfileCell',
      sortable: false
    },
    {
      name: 'E-Mail-Adresse',
      attribute: 'email'
    },
    {
      name: 'Kategorie',
      attribute: 'category'
    },
    {
      name: 'Nachricht',
      attribute: 'message',
      type: 'SupportShortendMessageCell'
    },
    {
      name: 'Datum',
      attribute: 'created_at',
      type: 'DateTimeCell'
    },
    {
      name: 'Status',
      attribute: 'read',
      type: 'ToggleCell',
      url: 'read_toggle_url'
    },
    {
      name: 'Bearbeitung',
      type: 'SupportReadByCell'
    },
    {
      name: 'Lesen',
      attribute: 'detail_page_url',
      type: 'ActionCell',
      label: 'Lesen',
      sortable: false
    }
  ]}})
}
var staticRenderFns = []

export { render, staticRenderFns }